export function calculateScaledVideoDimensions(containerWidth: number, containerHeight: number, videoBaseWidth: number, videoBaseHeight: number): {
  scaledVideoWidth: number;
  scaledVideoHeight: number;
  scale: number;
  offsetX: number;
  offsetY: number;
} {
  const videoAspectRatio = videoBaseWidth / videoBaseHeight;
  const containerAspectRatio = containerWidth / containerHeight;

  let scaledVideoWidth;
  let scaledVideoHeight;
  let scale;
  let offsetX = 0;
  let offsetY = 0;

  if (containerAspectRatio > videoAspectRatio) {
    // Container is wider, scale based on height to fit within
    scale = containerHeight / videoBaseHeight;
    scaledVideoHeight = containerHeight;
    scaledVideoWidth = videoBaseWidth * scale;
    offsetX = (containerWidth - scaledVideoWidth) / 2;
  }
  else if (containerAspectRatio < videoAspectRatio) {
    // Container is taller, scale based on width to fit within
    scale = containerWidth / videoBaseWidth;
    scaledVideoWidth = containerWidth;
    scaledVideoHeight = videoBaseHeight * scale;
    offsetY = (containerHeight - scaledVideoHeight) / 2;
  }
  else {
    // Aspect ratios match
    scale = containerWidth / videoBaseWidth;
    scaledVideoWidth = containerWidth;
    scaledVideoHeight = containerHeight;
  }

  return {
    scaledVideoWidth,
    scaledVideoHeight,
    scale,
    offsetX,
    offsetY,
  };
}
